/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig } from 'axios'
import { Page } from 'features/ui/types'
import InsightContentType, {
  InsightContentTypeStrings
} from 'components/insightContent/enum/InsightContentType'
import { convertResult } from 'utils/runSearchUtil'
import { ServiceTypeStrings } from 'enums/ServiceType'
import * as API from 'api'
import { RunSearch } from 'schemas/action/RunSearchSchema'
import * as liveReportServiceAPI from 'liveReportService'

export interface GetInsightContentDataParam {
  insightContentType: InsightContentTypeStrings
  searches: RunSearch[]
  timestamp?: number
  requestConfig?: AxiosRequestConfig
}

export const getInsightContentData = createAsyncThunk(
  'insightContent/getInsightContentData',
  async (
    { searches, insightContentType, timestamp, requestConfig }: GetInsightContentDataParam,
    { getState }
  ) => {
    const promises: Promise<any>[] = []
    const serivceTypes: ServiceTypeStrings[] = []
    const namesMaps: Map<string, string>[] = []

    // handle dynamic API
    const {
      ui: { page }
    } = getState() as { ui: { page: string } }
    const dynamicAPI = page === Page.LiveReport ? liveReportServiceAPI : API

    searches.forEach(({ queryData, service, namesMap }, idx) => {
      const spec = queryData!.keyMap!.get('spec')
      const response = dynamicAPI.runSearch(-1, '', spec, 'insightModal', timestamp, requestConfig)
      promises.push(response)
      serivceTypes[idx] = service.type!
      namesMaps[idx] = namesMap
    })

    const results = await Promise.all(promises)
    const data = results.map((res, idx) => ({
      ...convertResult(serivceTypes[idx], namesMaps[idx], res.data)
    }))

    let shouldRetry = false

    if (
      insightContentType === InsightContentType.SOUND_BITE &&
      // @ts-ignore
      data?.[0]?.results?.[0]?.data?.totalCount === '0'
    ) {
      shouldRetry = true
    }

    return { data, insightContentType, shouldRetry }
  }
)
